export default {
  name: 'organization',
  translationKey: 'organization-module',
  routePrefix: 'organization',
  routeNamePrefix: 'admin.organization',
  directRoutesAvailable: false,
}
